import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import CarouselItemWrapper from '../../common/CarouselProvider/CarouselItemWrapper/CarouselItemWrapper.esm.js';
import CarouselProvider from '../../common/CarouselProvider/CarouselProvider.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { chunk } from 'lodash';
import { v4 } from 'uuid';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import LogoList from './LogoList.esm.js';
import styles from './LogosSection.module.esm.js';

var accessibleHeading = 'logos section carousel';
var ITEMS_TO_SHOW_CAROUSEL = 12;
var LogosSection = function (_a) {
    var id = _a.id, _b = _a.fields, body = _b.body, heading = _b.heading, images = _b.images, internalName = _b.internalName, analyticsEvents = _b.analyticsEvents, dataCy = _a["data-cy"];
    var _c = __read(React.useState(''), 2), carouselId = _c[0], setCarouselId = _c[1];
    var _d = __read(React.useState([]), 2), items = _d[0], setItems = _d[1];
    React.useEffect(function () {
        // As uuidv4 is not deterministic it needs to be set on the client side
        // to avoid SSR problems
        setCarouselId(v4());
    }, []);
    React.useEffect(function () {
        if (images.length > ITEMS_TO_SHOW_CAROUSEL)
            setItems(chunk(images, ITEMS_TO_SHOW_CAROUSEL));
    }, [images]);
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: styles.root, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement(Grid, { className: styles.grid },
            React.createElement("header", { className: styles.header },
                React.createElement(NvMarkdownInline, { className: styles.title, element: "h2", elementWrapper: NvHeading, level: 1 }, heading),
                !!body && React.createElement(NvMarkdown, { className: classNames(styles.body, 'nv-subheading-1') }, body)),
            images.length > ITEMS_TO_SHOW_CAROUSEL ? (React.createElement("div", { className: styles.logosWrapper },
                React.createElement(CarouselProvider, { accessibleHeading: accessibleHeading, carouselId: carouselId, items: items, showDots: false, theme: "logos" }, items.map(function (images, index) { return (React.createElement(CarouselItemWrapper, { carouselId: carouselId, index: index, key: "key_".concat(carouselId, "_").concat(index), numberOfItems: items.length, shouldCheckForWidth: true },
                    React.createElement(LogoList, { images: images }))); })))) : (React.createElement(LogoList, { images: images })))));
};

export { LogosSection as default };
//# sourceMappingURL=LogosSection.esm.js.map
